.badge {
    padding: var(--spacer-8);
    font: var(--font-p-12);
    background-color: var(--beige);
    color: var(--gray-700);
}

.badgeDiscontinued {
    composes: badge;
    background-color: var(--gray-300);
    color: var(--gray-900);
}
